// @flow @jsx h
import { h, Component } from 'preact'
import { connect } from '../../lib/provider'

import { QuestionForm } from './QuestionForm'
import { Questions } from './Questions'
import { TagList } from './TagList'
import { TagLinks } from './TagLinks'

/* styles */
import styles from './App.css'

/* types */
import type { FeedItem } from './types'

type Props = {
  sendGaEvent: (Object) => void,
  feedId: string,
  feed: FeedItem[],
  showForm: boolean,
  showTitle: boolean,
  showQuestions: boolean,
  showTagList: boolean,
  showLinks: boolean,
  tags: Array<mixed>,
  filter: string,
  id: string,
  antall: string
}

class _App extends Component<Props> {
  render () {
    const {
      feed,
      feedId,
      showForm,
      showTitle,
      showQuestions,
      showTagList,
      showLinks,
      tags,
      filter,
      id,
      antall
    } = this.props
    return (
      <div class={styles.app}>
        {showTitle && <h1>Spørsmål og svar</h1>}
        {showForm && <QuestionForm feedId={feedId} />}
        {showTagList && <TagList tags={tags} filter={filter} />}
        {showQuestions && <Questions feed={feed} filter={filter} antall={antall} id={id} />}
        {showLinks && <TagLinks tags={tags} />}
      </div>
    )
  }
}

const connector = connect()
// const connector = connect(mapContextToProps)
export const App = connector(_App)
